import { useIntl } from 'react-intl'

import { convertUTCtoMSK, formatSum } from '../../../../utils'
import { IsGranted } from '../../auth/PrivateRoute'
import { ROLE, useAuth } from '../../auth'
import { IPayoutTicket } from '../payoutTickets.types'
import { getLatestTransaction } from '../utils/getLatestTransaction'
import { payoutTypeLabel } from '../core/payoutRequisites'
import { AuditLogLink } from '../../Logs/routes/Audit/components/AuditLogLink'
import { ClientCell } from '../../../common/ClientCell'
import { PayoutTokenLink } from '../../../common/PayoutTokenLink'

const TicketItem = ({ ticket, typePage }: { ticket: IPayoutTicket; typePage?: string }) => {
  const intl = useIntl()
  const { currentUser } = useAuth()
  
  const latestTransaction = getLatestTransaction(ticket.transactions)

  return (
    <tr>
      <td>
        <p className='mb-4'>
          <PayoutTokenLink token={ticket.token} />
        </p>
        <div className='d-flex-column'>
          <p className='fw-bold fs-9'>ID адаптера:</p>
          <span className='fs-9'>{latestTransaction?.paymentId || '-'}</span>
        </div>
      </td>
      <td>{convertUTCtoMSK(ticket.createdAt)}</td>
      <td>{payoutTypeLabel(ticket)}</td>
      {typePage !== 'Active' && ticket.completionDate && (
        <td>{convertUTCtoMSK(ticket.completionDate)}</td>
      )}
      <td>{ticket.amount ? formatSum(ticket.amount) : '-'}</td>
      {typePage !== 'Active' && (
        <td>{ticket.requestedAmount !== null ? formatSum(ticket.requestedAmount) : '-'}</td>
      )}
      <ClientCell externalId={ticket.externalUser?.externalId} token={ticket.externalUser?.token} />
      {!IsGranted([ROLE.ROLE_MATCHING_OPERATOR], currentUser) && (
        <td>{ticket.merchant.title}</td>
      )}
      {IsGranted([ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_SENIOR_OPERATOR, ROLE.ROLE_OPERATOR, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER], currentUser) && (
        <td>{latestTransaction?.adapterStatus || '-'}</td>
      )}
      <td>{latestTransaction?.paymentAdapter || '-'}</td>
      {typePage === 'Active' ? <></> : <td>{ticket.executor ? ticket.executor.uuid : '-'}</td>}

      {IsGranted([ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_SENIOR_OPERATOR, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER], currentUser) && (
        <td>{ticket?.cashBox?.title || '-'}</td>
      )}

      <td>{intl.formatMessage({ id: `ticket.status.${ticket.status}` })}</td>
      <td className='text-end'>
        <AuditLogLink ticketToken={ticket.token} />
      </td>
    </tr>
  )
}

export default TicketItem
